import React, { FunctionComponent, ReactNode } from "react";
import { FormGroup } from "react-bootstrap";
import { Placement } from "react-bootstrap/cjs/types";
import ReanalyzeFormInputLabel from "../../reanalyze/reanalyze-form-input-label/ReanalyzeFormInputLabel";
import FormCheckboxWidget from "../../../../../forms/components/FormCheckboxWidget";
import { Sizes } from "../../../../../components/Icon";

export const LAYOUT_TYPE = {
  ROW: "row",
  COL: "col",
  NONE: "none"
};

type ReanalyzeFormInputProps = {
  help?: string;
  helpImportant?: string | null;
  className?: string;
  timestamp?: string;
  name: string;
  label: ReactNode;
  labelIcon: string;
  labelIconSize: Sizes;
  disabled?: boolean;
  skipColon?: boolean;
  layout: string;
  checked?: boolean;
  isLoadingAnalysisStatus?: boolean;
  tooltipMessage?: string;
  tooltipPlacement?: Placement;
};

const ReanalyzeFormInput: FunctionComponent<ReanalyzeFormInputProps> = ({
  label,
  labelIcon,
  labelIconSize,
  help,
  helpImportant,
  timestamp,
  skipColon = true,
  className,
  name,
  disabled,
  layout,
  checked,
  isLoadingAnalysisStatus = false,
  tooltipMessage,
  tooltipPlacement = "top"
}) => (
  <div className="reanalyze-form-item">
    <FormGroup>
      <FormCheckboxWidget
        name={name}
        label={
          <ReanalyzeFormInputLabel
            name={name}
            labelIcon={labelIcon}
            labelIconSize={labelIconSize}
            layout={layout}
            disabled={disabled}
            label={label}
            help={help}
            helpImportant={helpImportant}
            timestamp={timestamp}
            isLoadingAnalysisStatus={isLoadingAnalysisStatus}
          />
        }
        disabled={disabled}
        className={className}
        checkboxClassname={"d-flex align-items-center"}
        skipColon={skipColon}
        marginBottom={0}
        checked={checked}
        data-testid={name}
        standaloneTooltip={{
          message: tooltipMessage,
          placement: tooltipPlacement
        }}
      />
    </FormGroup>
  </div>
);

export default ReanalyzeFormInput;
